
import { useFormik, FormikProvider } from 'formik';
import * as Yup from 'yup';
import ButtonWithLoader from '../../../../common/components/ui/loading/ButtonLoading';
import TextAreaFormik from '../../../../common/components/form/TextAreaFormik';

type FormPropsCreatePartners = {
  onSubmit: (values) => Promise<{ ok: boolean, errors?: unknown[] }>;
  data,
  formRequestErrors?: { message: string, path: string[] }[]
};

const validationSchema = Yup.object({
  suspendedNotes: Yup.string().required('O motivo é obrigatório.'),
});

function FormSuspendRepossession(props: FormPropsCreatePartners) {
  const formik = useFormik({
    initialValues: {
      suspendedNotes: props.data?.suspendedNotes || '',
    },
    validationSchema,
    enableReinitialize: true,
    onSubmit: async (data) => {
      const result = await props.onSubmit(data)
      if (result.ok) {
        formik.setValues({
          suspendedNotes: '',
        });
      }
      return result
    },
  });

  return (
    <form onSubmit={formik.handleSubmit}>
      <FormikProvider value={formik}>
        <section>
          <div className="grid grid-cols-3 gap-2 mb-10">
            <div className="grid grid-cols-1 text-sm lg:text-lg col-span-3 gap-2">
              <div className="col-span-3">
                <TextAreaFormik
                  label="Informe o motivo da suspensão do recolhimento:"
                  name="suspendedNotes"
                  required={true}
                />
              </div>
            </div>
          </div>
        </section>
        <div className="w-full flex justify-end">
          <ButtonWithLoader isLoading={formik.isSubmitting} disabled={!formik.isValid} onClick={formik.handleSubmit}> Salvar </ButtonWithLoader>
        </div>
      </FormikProvider >
    </form >
  );
}

export default FormSuspendRepossession;


